export const HELP_URL = 'https://sites.google.com/goweft.com/intro-to-weft-billing/home';

export const NAMED_ACCOUNTS = Object.freeze({
  au10tix: 'Au10tix',
  vi: 'VI.Ltd',
});